"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import 'react';
import TableView from '../../../../../views/TableView.mjs';
import TableColumnView from '../../../../../views/TableColumnView.mjs';
import TableBodyView from '../../../../../views/TableBodyView.mjs';
import TableRowView from '../../../../../views/TableRowView.mjs';
import SkeletonTextView from '../../../../../views/SkeletonTextView.mjs';
import TableHeaderView from '../../../../../views/TableHeaderView.mjs';
import TableCellView from '../../../../../views/TableCellView.mjs';

const TableLoadingView = (props) => {
  return /* @__PURE__ */ jsxs(TableView, { ...props, children: [
    /* @__PURE__ */ jsx(TableHeaderView, { children: /* @__PURE__ */ jsx(TableColumnView, { children: /* @__PURE__ */ jsx(SkeletonTextView, { width: "100%" }) }) }),
    /* @__PURE__ */ jsx(TableBodyView, { children: Array.from(Array(5)).map((_, i) => /* @__PURE__ */ jsx(TableRowView, { children: /* @__PURE__ */ jsx(TableCellView, { children: /* @__PURE__ */ jsx(SkeletonTextView, { width: "100%" }) }) }, i)) })
  ] });
};

export { TableLoadingView };
//# sourceMappingURL=TableLoadingView.mjs.map
